// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".el-select-dropdown__item[data-v-412751ad]{max-width:350px;white-space:normal;overflow:unset;height:auto;line-height:normal;padding-top:10px;padding-bottom:10px}[data-v-412751ad] .el-select{position:relative!important}[data-v-412751ad] .el-scrollbar__view{padding:10px}[data-v-412751ad] .el-select-dropdown__item{max-width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
